module.exports = __webpack_public_path__ + "static/media/left.aa83bc99.svg";